<template>
    <v-container>
        <div class="padding-block"></div>
        <v-row>
            <v-col>
                <div class="font-weight-bold mt-10 title-page" tabindex="0">Ajuda</div>
            </v-col>
        </v-row>

        <br />

        <div class="mt-4" v-if="dataset.loading">
            <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
        </div>

        <div v-html="dataset.description" tabindex="0"></div>
        <br />

        <div v-if="Object.keys(groupedItems).length > 0">
            <v-item-group v-for="(categoryItems, categoryId) in groupedItems" :key="categoryId"
                class="ml-0 align-center mt-6">
                <v-row class="d-flex align-center">
                    <v-item>
                        <template>
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-icon v-on="on" color="primary" class="mr-2">
                                        {{ categoryIcon(categoryId) }}
                                    </v-icon>
                                </template>
                                <span>Recursos da categoria {{ categoryName(categoryId) }}</span>
                            </v-tooltip>
                        </template>
                    </v-item>
                    <v-item>
                        <div class="font-weight-bold text-uppercase" tabindex="0">
                            {{ categoryName(categoryId) }}
                        </div>
                    </v-item>
                </v-row>
                <br>

                <div v-for="(item) in categoryItems" :key="item.id" class="mb-3">
                    <v-card class="pa-2" elevation="2">
                        <v-list-item class="px-0">
                            <v-row class="align-center" no-gutters>
                                <v-col cols="12" sm="2" class="d-flex align-center">
                                    <div class="thumbnail-container">
                                        <v-img v-if="getResourcePreview(item).type === 'youtube'"
                                            :src="getYouTubeThumbnail(item)" alt="Thumbnail do vídeo do YouTube"
                                            class="video-preview" width="150" height="84" />
                                        <v-img v-else-if="getResourcePreview(item).type === 'image'" :src="item.link"
                                            alt="Thumbnail do recurso" class="thumbnail" max-width="75" max-height="75"
                                            @error="onPreviewError(item)" />
                                        <canvas v-else-if="getResourcePreview(item).type === 'video'"
                                            :id="'thumbnail-canvas-' + item.id" class="thumbnail" width="75" height="75"
                                            ref="videoCanvas"></canvas>
                                        <v-icon v-else :color="getResourcePreview(item).color" class="thumbnail-icon">
                                            {{ getResourcePreview(item).icon }}
                                        </v-icon>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="10" class="pl-1">
                                    <div class="font-weight-bold text-uppercase">{{ item.name }}</div>
                                    <div class="mt-1" v-html="item.description"></div>
                                    <div class="mt-n3 ">
                                        Publicado em <span class="font-weight-medium">{{ formatDate(item.created_at)
                                            }}</span> -
                                        Atualizado em <span class="font-weight-medium">{{ formatDate(item.updated_at)
                                            }}</span>
                                    </div>
                                    <div class="mt-1 d-flex align-left ">
                                        <div class="d-flex align-center"
                                            v-if="getResourcePreview(item).type === 'youtube'">
                                            <v-tooltip bottom>
                                                <template #activator="{ on, attrs }">
                                                    <v-icon v-on="on" v-bind="attrs" @click="openVideoDialog(item)"
                                                        class="mr-2">
                                                        mdi-eye-outline
                                                    </v-icon>
                                                </template>
                                                <span>Abrir vídeo em janela</span>

                                            </v-tooltip>
                                            <span class="caption ml-1 mediumGray--text">Visualizar</span>
                                        </div>

                                        <div class="align-left ml-10" v-if="getResourcePreview(item).type === 'youtube'">
                                            <v-tooltip bottom>
                                                <template #activator="{ on, attrs }">
                                                    <v-icon v-on="on" v-bind="attrs" @click="openLink(item)">
                                                        mdi-play-circle-outline
                                                    </v-icon>
                                                </template>
                                                <span>Abrir em nova aba do navegador</span>
                                            </v-tooltip>
                                            <span class="caption ml-1 mediumGray--text" >Assistir</span>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-list-item>
                    </v-card>
                </div>
                <br>
            </v-item-group>
        </div>
        <div v-else class="mb-4">Não há recursos de ajuda disponíveis.</div>

        <v-dialog v-model="videoDialog" max-width="600px">
            <v-card>
                <v-card-title class="d-flex justify-space-between align-center">
                    <span>Visualizar Vídeo</span>
                    <v-btn icon @click="onDialogClose">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <div class="video-container">
                        <iframe :src="selectedVideoUrl" class="video-full" title="Vídeo do YouTube" frameborder="0"
                            allow="autoplay; encrypted-media" allowfullscreen loading="lazy"></iframe>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>
  
<script>
    import 'moment/locale/pt-br'

    import categoryTypes from '@/common/data/help-categories-types.data'
    
    import object from '@/common/util/object'
    import axios from 'axios'
    
    export default {
        data() {
            return {
                dataset: {
                    filteredQuestions: [],
                    loading: false,
                    description: '',
                    filter: {
                        name: ''
                    },
                    data: [],
                },
                activePanel: null,
                items: [],
                categoryTypes: categoryTypes,
                videoThumbnails: {},
                videoDialog: false, 
                selectedVideoUrl: '',
            }
        },
    
        mounted() {
            this.$nextTick(() => {
                this.items.forEach(item => {
                    if (this.getResourcePreview(item).type === 'video') {
                        this.captureThumbnail(item);
                    }
                });
            });
        },

        computed: {
            groupedItems() {
                const grouped = this.items
                    .filter(item => item.is_active === 1)
                    .reduce((acc, item) => {
                        if (!acc[item.category]) {
                            acc[item.category] = [];
                        }
                        acc[item.category].push(item);
                        return acc;
                    }, {});
                Object.keys(grouped).forEach(category => {
                    grouped[category].sort((a, b) => a.priority - b.priority);
                });
                return grouped;
            },
        },
        
        created() {
            this.$ga.event({
                eventCategory: 'page',
                eventAction: 'action',
                eventLabel: 'click',
                eventValue: 'contact'
            })

            this.loadData()
        },
    
        methods: {
            async loadData() {
                await this.load()
                await this.loadText()
            },

            categoryName(categoryId) {
                const category = this.categoryTypes.find(c => c.id == categoryId);
                return category ? category.name : `Categoria ${categoryId}`;
            },

            categoryIcon(categoryId) {
                const category = this.categoryTypes.find(c => c.id === Number(categoryId));
                
                if (!category) {
                    return 'mdi-folder-outline';
                }

                const normalizedName = category.name
                .toLowerCase()
                .normalize('NFD')              
                .replace(/[\u0300-\u036f]/g, '') 
                .replace(/\s+/g, '')            
                .trim()

                const proximityMap = [
                    { keywords: ['video'], icon: 'mdi-video' },
                    { keywords: ['tutorialpdf', 'pdf'], icon: 'mdi-file-pdf-box' },
                    { keywords: ['imagem', 'imagens', 'foto', 'fotos'], icon: 'mdi-image' },
                    { keywords: ['documentacao', 'documento', 'documentos'], icon: 'mdi-file-document' },
                ];

                for (const rule of proximityMap) {
                    for (const keyword of rule.keywords) {
                    if (normalizedName.includes(keyword)) {
                        return rule.icon;
                    }
                    }
                }

                return 'mdi-file-outline';
            },

            getResourcePreview(item) {
                const youtubeRegex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
                const youtubeMatch = item.link.match(youtubeRegex);
                if (youtubeMatch) {
                    const videoId = youtubeMatch[1];
                    return {
                    type: 'youtube',
                    embedUrl: `https://www.youtube.com/embed/${videoId}?mute=1&controls=1`,
                    icon: 'mdi-youtube',
                    color: 'red',
                    };
                }
                const extension = item.link.split('.').pop().toLowerCase();

                if (['mp4', 'webm', 'ogg', 'avi'].includes(extension)) {
                    return { type: 'video', icon: 'mdi-video', color: 'blue' };
                } else if (extension === 'pdf') {
                    return { type: 'pdf', icon: 'mdi-file-pdf-box', color: 'red' };
                } else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
                    return { type: 'image', icon: 'mdi-image', color: 'green' };
                } else {
                    return { type: 'other', icon: 'mdi-file', color: 'grey' };
                }
            },

            formatDate(dateString) {
                const date = new Date(dateString);
                return date.toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                });
            },
        
            openLink(item) {
                window.open(item.link, '_blank');
            },

            onDialogClose() {
                
                this.selectedVideoUrl = '';
                this.videoDialog = false;
            
            },

            openVideoDialog(item) {
                if (this.getResourcePreview(item).type === 'youtube') {
                    const videoId = item.link.match(/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/)[1];
                    this.selectedVideoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&controls=1`;
                    this.videoDialog = true;
                }
            },

            getYouTubeThumbnail(item) {
                const youtubeMatch = item.link.match(/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/);
                if (youtubeMatch) {
                  const videoId = youtubeMatch[1];
                  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                }
                return '';
            },

            onPreviewError(item) {
                this.$set(this.videoThumbnails, item.id, {
                    type: 'icon',
                    icon: this.getResourcePreview(item).icon,
                    color: this.getResourcePreview(item).color,
                });
            },

            captureThumbnail(item) {
                if (this.getResourcePreview(item).type !== 'video') return;

                const video = document.createElement('video');
                video.src = item.link;
                video.crossOrigin = 'anonymous';
                video.preload = 'metadata';

                video.addEventListener('loadedmetadata', () => {
                    video.currentTime = 1;
                });

                video.addEventListener('seeked', () => {
                    const canvas = document.getElementById(`thumbnail-canvas-${item.id}`);
                    if (!canvas) return;

                    const context = canvas.getContext('2d');
                    context.drawImage(video, 0, 0, canvas.width, canvas.height);
                    this.$set(this.videoThumbnails, item.id, { type: 'canvas', src: canvas.toDataURL('image/png') });
                    video.remove();
                });

                video.addEventListener('error', () => {
                    this.$set(this.videoThumbnails, item.id, { type: 'icon', icon: 'mdi-video', color: 'blue' });
                    video.remove();
                });
            },

            async load() {
                this.dataset.loading = true
        
                try {
                    const result = await axios.get('/api/helps', { params: { start: 1, limit: 100000, search: {} }
                })
                
                this.items = await result.data.content.data;
                
                } catch (error) {
                    this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 })
                } finally {
                    this.dataset.loading = false
                }
            },
    
            async loadText() {
                try {
                    const result = await axios.get(`/api/dynamic-infos/keys`, {
                        params: { keys: 'help-request-description' }
                    })

                    this.dataset.description = result.data.content && result.data.content.length > 0 ? result.data.content[0].value : '';

                } catch (error) {
                    this.$dialog.notify.error(this.$codes(error), {
                        position: 'top-right',
                        timeout: 2000
                    })
                }
            }
        }
    }

</script>

<style scoped>

.mediumGray--text {
  color: #666;
}
.thumbnail-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 150px;
  margin-left: 8px;
}
.thumbnail {
  width: 75px;
  height: 75px; 
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ddd;
}
.video-preview-wrapper {
  width: 150px; 
  height: 84px; 
  cursor: pointer;
  position: relative;
}
.video-preview {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  border: 1px solid #ddd;
}
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
}
.thumbnail-icon {
  font-size: 75px; 
}
.video-container {
  position: relative;
  padding-bottom: 56.25%; 
  height: 0;
  overflow: hidden;
}
.video-full {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.v-card {
  border-radius: 8px;
}
</style>